import cx from 'classnames'
import React from 'react'

import styles from './index.module.scss'

export function BlockQuote (props) {
  return (
    <blockqoute
      {...props.attributes}
      className={cx(props.attributes.className, styles.blockQuote)}
      style={props.style}
    >
      {props.children}
    </blockqoute>
  )
}
